import { useNavigate } from 'react-router-dom'

import { Header } from 'components/app-shell/Header'
import { AuthButton } from 'components/auth/AuthButton'
import { useAuth } from 'contexts/AuthContext'
import { UploadDropzone } from 'modules/files/components/UploadDropzone'
import { useUploadPreparation } from 'modules/files/hooks/useUploadPreparation'

const TEXT_APP_NAME = 'Pocket Coach'

export const NewUploadScreen = () => {
  /* --- Section 1: Hooks --- */
  const navigate = useNavigate()
  const { loading, user } = useAuth()
  const { error, handleFilesDropped, isPreparing, selectedFile, selectedFiles } = useUploadPreparation({
    onUploadComplete: conversationId => {
      navigate(`/c/${conversationId}`, { replace: true })
    },
  })

  /* --- Section 6: Render --- */
  return (
    <div className="landing-page">
      {user ? <Header variant="floating-menu" /> : null}
      <div className="landing-content">
        <h1 className="app-title">{TEXT_APP_NAME}</h1>
        <div className="mode-actions">
          {user ? (
            <div>
              <UploadDropzone
                error={error}
                hasUploadPermission={Boolean(user)}
                isPreparing={isPreparing}
                isUserLoading={loading}
                onFilesDropped={handleFilesDropped}
                selectedFile={selectedFile}
                selectedFiles={selectedFiles}
              />
            </div>
          ) : (
            <div className="signin-cta">
              <AuthButton className="signin-cta-button" />
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
